class ContactForm{

    constructor(){        
        this.querySelector()
        this.events()
        
    }

    querySelector(){
        this.inputs = document.querySelectorAll('.wpcf7-form-control')
    }

    events(){
        this.inputs.forEach(input=>input.addEventListener('focus', ()=>this.clearInput(input))) ;
        this.inputs.forEach(input=>input.addEventListener('blur', ()=>this.setInputToDefault(input))) ;   
    }

    clearInput(input){
        
        if (input.value === input.defaultValue) {
            input.value = '';
          }
    }
    setInputToDefault(input){
        
        if (input.value === '') {
            input.value = input.defaultValue;
          }
    }



}

export default new ContactForm()